<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('dispath.users')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card mar-to-15">
          <div class="card-content">

            <!-- FILTERS -->
            <div class="table-top" style="display: flex; justify-content: space-between; align-items: flex-end; gap: 10px; flex-wrap: nowrap; margin-bottom: 20px;">

              <!-- LEFT: FILTERS -->
              <div class="left-group" style="display: flex; flex-wrap: nowrap; gap: 8px; align-items: flex-end; flex: 0 1 auto;">

                <!-- USER ID -->
                <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                  <label>{{ $t('catalogProd.id') }}</label>
                  <el-input
                    v-model="searchId"
                    :placeholder="$t('catalogProd.id')"
                    size="small"
                    clearable
                  />
                </div>

                <!-- NAME (Search by firstname/lastname) -->
                <div class="form-group" style="flex: 0 0 180px; margin: 0;">
                  <label>{{ $t('catalogProd.name') }}</label>
                  <el-input
                    v-model="search"
                    :placeholder="$t('catalogProd.name')"
                    size="small"
                    clearable
                  />
                </div>

                <!-- LOCATION -->
                <div class="form-group" v-if="locations.length" style="flex: 0 0 200px; margin: 0;">
                  <label>{{ $t('orders.location') }}</label>
                  <el-select
                    v-model="selectedLocations"
                    :placeholder="$t('general.select')"
                    size="small"
                    multiple
                    collapse-tags
                    clearable
                    style="width: 100%;">
                    <el-option
                      v-for="loc in locations"
                      :key="loc.true_id"
                      :label="loc.name"
                      :value="loc.true_id">
                    </el-option>
                  </el-select>
                </div>

                <!-- SEARCH BUTTON -->
                <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                  <button class="btn add" @click="searchUsers" :title="$t('reports.search')" style="width: 100%; font-size: 12px; padding: 4px 8px;">
                    <i class="ti-search"></i> {{ $t('general.search') }}
                  </button>
                </div>

              </div>

              <!-- RIGHT: ADD BUTTON -->
              <div class="right-group" style="flex: 0 0 auto;">
                <button class="btn add" @click.prevent="openAssociateTablesModal" :title="$t('general.associateTables')" style="font-size: 12px; padding: 4px 8px; margin-right: 6px;">
                  <i class="ti-layout-grid2"></i>
                  {{ $t('general.associateTables') }}
                </button>
                <button class="btn add" @click.prevent="goToAdd" :title="$t('general.add')" style="font-size: 12px; padding: 4px 8px;">
                  <img src="/static/img/icons/add.png">
                  {{$t('general.add')}}
                </button>
              </div>

            </div>

            <data-tables
              v-loading="loading"
              :data="tableData"
              :search-def="{}"
              :pagination-def="{}"
              :table-props="{'border': false}"
              style="width: 100%">

              <!-- Define your table columns -->
              <el-table-column
                min-width="10"
                prop="name"
                label="ID">
                <template slot-scope="props">
                  <div class="cell-center">{{ props.row.id || '-' }}</div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="30"
                prop="location"
                :label="$t('orders.location')">
                <template slot-scope="props">
                  <div class="cell-center">
                    <template v-if="props.row.location_details && props.row.location_details.length">
                      <span v-for="(locId, index) in props.row.location_details" :key="locId">
                        {{ getLocationName(locId) }}<template v-if="index < props.row.location_details.length - 1">, </template>
                      </span>
                    </template>
                    <template v-else>-</template>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="30"
                prop="firstname"
                label="Firstname">
                <template slot-scope="props">
                    <div class="cell-center">{{ props.row.firstname ? props.row.firstname : "-" }}</div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="30"
                prop="lastname"
                label="Lastname">
                <template slot-scope="props">
                    <div class="cell-center">{{ props.row.lastname ? props.row.lastname : "-" }}</div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="20"
                prop="active"
                :label="$t('settingLocationGroups.active')">
                <template slot-scope="props">
                  <div class="cell-center" @click.stop>
                    <p-switch
                      v-model="props.row.active"
                      type="success"
                      @input="handleActive(props.row, $event)"
                    />
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                :width="320"
                :label="$t('general.actions')">
                <template slot-scope="props">
                  <a
                    class="btn delete mar-rt-10"
                    :title="$t('marketingCampaigns.send')"
                    @click="handleDelete(props.row.id)">
                    <img src="/static/img/icons/icon-close.png">
                    {{$t('general.delete')}}
                  </a>
                  <div class="edit" @click="goToRecord(props.row, $event, props.row)">
                    <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </div>

    <vmodal
      name="associateTablesModal"
      class="associateTablesModal"
      :minWidth="1200"
      :minHeight="850"
      :adaptive="true"
    >
      <div class="associate-modal">
        <div class="associate-modal__header">
          <div class="associate-modal__title">{{ $t('general.associateTables') }}</div>
        </div>

        <div class="associate-modal__body">
          <!-- SECTION 1: USERS -->
          <div class="associate-section">
            <div class="associate-section__heading">{{ $t('general.associateChooseUsers') }}</div>

            <div class="associate-filters">
              <div class="form-group" v-if="locations.length" style="flex: 0 0 280px; margin: 0;">
                <label>{{ $t('orders.location') }}</label>
                <el-select
                  v-model="assocUserLocations"
                  :placeholder="$t('general.select')"
                  size="small"
                  multiple
                  collapse-tags
                  clearable
                  style="width: 100%;">
                  <el-option
                    v-for="loc in locations"
                    :key="loc.true_id"
                    :label="loc.name"
                    :value="loc.true_id">
                  </el-option>
                </el-select>
              </div>

              <div class="form-group" style="flex: 1 1 280px; margin: 0;">
                <label>{{ $t('catalogProd.name') }}</label>
                <el-input
                  v-model="assocUserSearch"
                  :placeholder="$t('catalogProd.name')"
                  size="small"
                  clearable
                  @keyup.enter.native="fetchAssocUsers"
                />
              </div>

              <div class="form-group" style="flex: 0 0 120px; margin: 0;">
                <button class="btn add" @click.prevent="fetchAssocUsers" :title="$t('general.search')" style="width: 100%; font-size: 12px; padding: 4px 8px;">
                  <i class="ti-search"></i> {{ $t('general.search') }}
                </button>
              </div>
            </div>

            <div class="associate-grid">
              <div class="associate-results">
                <div class="associate-results__title">{{ $t('general.search') }}</div>
                <div class="associate-results__list" v-loading="assocLoadingUsers">
                  <div
                    v-for="u in assocUsersResults"
                    :key="u.id"
                    class="associate-row"
                    @click="toggleAssocUser(u)"
                  >
                    <input type="checkbox" :checked="isAssocUserSelected(u.id)" @click.stop="toggleAssocUser(u)">
                    <div class="associate-row__main">
                      <div class="associate-row__name">{{ formatUserName(u) }}</div>
                      <div class="associate-row__meta">
                        <span>ID: {{ u.id }}</span>
                        <span v-if="u.location_details && u.location_details.length"> · {{ u.location_details.map(getLocationName).join(', ') }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!assocUsersResults.length && !assocLoadingUsers" class="associate-empty">{{ $t('general.noResults') }}</div>
                </div>
              </div>

              <div class="associate-selected">
                <div class="associate-results__title">{{ $t('general.selected') }} ({{ assocSelectedUsers.length }})</div>
                <div class="associate-selected__box">
                  <div v-for="u in assocSelectedUsers" :key="u.id" class="associate-chip">
                    <span class="associate-chip__text">{{ formatUserName(u) }}</span>
                  </div>
                  <div v-if="!assocSelectedUsers.length" class="associate-empty">{{ $t('general.no_data') }}</div>
                </div>
              </div>
            </div>

            <div class="associate-section__actions">
              <button class="btn btn-info" @click.prevent="selectAllAssocUsers" :disabled="assocLoadingUsers || !assocUsersResults.length" style="font-size: 12px; padding: 4px 8px;">
                {{ $t('general.selectAll') }}
              </button>
              <button class="btn btn-danger" @click.prevent="clearAssocUsersSelection" :disabled="assocLoadingUsers || !assocSelectedUsers.length" style="font-size: 12px; padding: 4px 8px;">
                {{ $t('general.clearSelection') }}
              </button>
            </div>
          </div>

          <!-- SECTION 2: TABLES -->
          <div class="associate-section">
            <div class="associate-section__heading">{{ $t('general.associateChooseTables') }}</div>

            <div class="associate-filters">
              <div class="form-group" v-if="locations.length" style="flex: 0 0 280px; margin: 0;">
                <label>{{ $t('orders.location') }}</label>
                <el-select
                  v-model="assocTableLocations"
                  :placeholder="$t('general.select')"
                  size="small"
                  multiple
                  collapse-tags
                  clearable
                  style="width: 100%;">
                  <el-option
                    v-for="loc in locations"
                    :key="loc.true_id"
                    :label="loc.name"
                    :value="loc.true_id">
                  </el-option>
                </el-select>
              </div>

              <div class="form-group" style="flex: 0 0 260px; margin: 0;">
                <label>{{ $t('settingTable.maps') }}</label>
                <el-select
                  v-model="assocTableMaps"
                  :placeholder="$t('general.search')"
                  size="small"
                  multiple
                  filterable
                  collapse-tags
                  clearable
                  style="width: 100%;">
                  <el-option
                    v-for="m in assocMaps"
                    :key="m.id"
                    :label="m.name || ('ID ' + m.id)"
                    :value="m.id">
                  </el-option>
                </el-select>
              </div>

              <div class="form-group" style="flex: 0 0 220px; margin: 0;">
                <label>{{ $t('settingTable.zone') }}</label>
                <el-select
                  v-model="assocTableZone"
                  :placeholder="$t('general.select')"
                  size="small"
                  clearable
                  style="width: 100%;">
                  <el-option
                    v-for="z in assocZones"
                    :key="z.id"
                    :label="z.name"
                    :value="z.name">
                  </el-option>
                </el-select>
              </div>

              <div class="form-group" style="flex: 1 1 280px; margin: 0;">
                <label>{{ $t('settingTable.number') }}</label>
                <el-input
                  v-model="assocTableSearch"
                  :placeholder="$t('settingTable.number')"
                  size="small"
                  clearable
                  @keyup.enter.native="fetchAssocTables"
                />
              </div>

              <div class="form-group" style="flex: 0 0 120px; margin: 0;">
                <button class="btn add" @click.prevent="fetchAssocTables" :title="$t('general.search')" style="width: 100%; font-size: 12px; padding: 4px 8px;">
                  <i class="ti-search"></i> {{ $t('general.search') }}
                </button>
              </div>
            </div>

            <div class="associate-grid">
              <div class="associate-results">
                <div class="associate-results__title">{{ $t('general.search') }}</div>
                <div class="associate-results__list" v-loading="assocLoadingTables">
                  <div
                    v-for="t in assocTablesResults"
                    :key="t.id"
                    class="associate-row"
                    @click="toggleAssocTable(t)"
                  >
                    <input type="checkbox" :checked="isAssocTableSelected(t.id)" @click.stop="toggleAssocTable(t)">
                    <div class="associate-row__main">
                      <div class="associate-row__name">{{ formatTableName(t) }}</div>
                      <div class="associate-row__meta">
                        <span>ID: {{ t.id }}</span>
                        <span v-if="t.location_id"> · {{ getLocationName(t.location_id) }}</span>
                        <span v-if="t.zone"> · {{ t.zone }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="!assocTablesResults.length && !assocLoadingTables" class="associate-empty">{{ $t('general.noResults') }}</div>
                </div>
              </div>

              <div class="associate-selected">
                <div class="associate-results__title">{{ $t('general.selected') }} ({{ assocSelectedTables.length }})</div>
                <div class="associate-selected__box">
                  <div v-for="t in assocSelectedTables" :key="t.id" class="associate-chip">
                    <span class="associate-chip__text">{{ formatTableName(t) }}</span>
                  </div>
                  <div v-if="!assocSelectedTables.length" class="associate-empty">{{ $t('general.no_data') }}</div>
                </div>
              </div>
            </div>

            <div class="associate-section__actions">
              <button class="btn btn-info" @click.prevent="selectAllAssocTables" :disabled="assocLoadingTables || !assocTablesResults.length" style="font-size: 12px; padding: 4px 8px;">
                {{ $t('general.selectAll') }}
              </button>
              <button class="btn btn-danger" @click.prevent="clearAssocTablesSelection" :disabled="assocLoadingTables || !assocSelectedTables.length" style="font-size: 12px; padding: 4px 8px;">
                {{ $t('general.clearSelection') }}
              </button>
            </div>
          </div>
        </div>

        <div class="associate-modal__footer">
          <button type="button" class="btn btn-icon btn-danger mar-rt-10" @click.prevent="closeAssociateTablesModal" :disabled="assocSaving" :class="{'associate-confirm--loading': assocSaving}" :title="$t('general.cancel')">
            <i class="ti-close"></i>
            {{ $t('general.cancel') }}
          </button>
          <button
            type="button"
            class="btn btn-icon btn-success btn save"
            @click.prevent="onConfirmAssocClick"
            :disabled="isAssocConfirmDisabled"
            :class="{'associate-confirm--loading': assocSaving}"
          >
            <i class="ti-check"></i>
            <span v-if="!assocSaving">{{ $t('general.confirm') }}</span>
            <span v-else>{{ $t('general.loading') }}</span>
          </button>
        </div>
      </div>
    </vmodal>
  </div>
</template>

<script>

import swal from 'sweetalert2'
import PSwitch from 'src/components/UIComponents/Switch.vue'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import 'sweetalert2/dist/sweetalert2.css'

export default {
  components: {
    PSwitch
    // GeneralTopBar
  },
  created () {
    this.locations = this.$session.get('selectedCompanyData').locations_details || []
    this.getData()

    this.$bus.$on('refresh', this.handleRefresh)
  },
  watch: {
    assocTableLocations () {
      // refresh map options when location filter changes
      this.getAssocMaps()
    }
  },
  data () {
    return {
      loading: true,
      tableData: [],
      search: '',
      searchId: '',
      selectedLocations: [],
      locations: [],

      assocUserSearch: '',
      assocUserLocations: [],
      assocUsersResults: [],
      assocSelectedUsers: [],
      assocLoadingUsers: false,

      assocTableSearch: '',
      assocTableLocations: [],
      assocTableMaps: [],
      assocMaps: [],
      assocTableZone: '',
      assocZones: [],
      assocTablesResults: [],
      assocSelectedTables: [],
      assocLoadingTables: false,

      assocSaving: false
    }
  },
  computed: {
    isAssocConfirmDisabled () {
      return this.assocSaving || !this.assocSelectedUsers.length || !this.assocSelectedTables.length
    }
  },
  // mounted () {
  //   this.$bus.$on('refresh', this.handleRefresh)
  // },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  methods: {
    onConfirmAssocClick () {
      if (this.assocSaving) return
      if (!this.assocSelectedUsers.length || !this.assocSelectedTables.length) return
      this.confirmAssoc()
    },
    getLocationName (locationId) {
      const location = this.locations.find(loc => loc.id === locationId || loc.true_id === locationId)
      return location ? location.name : '-'
    },
    handleRefresh () {
      this.getData()
    },
    goToRecord (row, event, column) {
      // this.$router.push('/screens/kds/edit/' + row.id)

      if (typeof this.callback === 'function') {
        this.callback(row.id)
      } else {
        this.globalGoToRecord(row, event, column, '/pos/users/')
      }
    },
    goToAdd () {
      this.$router.push('/pos/users/add')
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    getData () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      // Add filters
      if (this.searchId) {
        data.id = this.searchId
      }
      if (this.search) {
        data.search = this.search
      }
      if (Array.isArray(this.selectedLocations) && this.selectedLocations.length) {
        data.location_ids = this.selectedLocations
      }

      this.apiRequest('/pos/all/users', 'GET', data, response => {
        if (response.status === true) {
          this.tableData = (response.data.pos_user || []).map(user => ({
            ...user,
            active: user.active === undefined || user.active === null
              ? true
              : !!(+user.active || user.active === true)
          }))
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    searchUsers () {
      this.getData()
    },
    handleActive (row, active) {
      const nextActive = !!active
      row.active = nextActive
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        pos_user: {
          ...row,
          active: nextActive
        }
      }
      this.apiRequest('/pos/user/' + row.id, 'PUT', data, (response) => {
        if (response.status === true) {
          swal({
            title: '',
            text: this.$t('general.success'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {}).catch(() => {})
        } else {
          row.active = !nextActive
          swal({
            title: '',
            text: this.$t('validations.wentWrong'),
            type: 'error',
            showConfirmButton: false,
            timer: 2000
          }).then(() => {}).catch(() => {})
        }
      })
    },
    openAssociateTablesModal () {
      this.$modal.show('associateTablesModal')
      this.assocUsersResults = []
      this.assocTablesResults = []
      this.assocSelectedUsers = []
      this.assocSelectedTables = []
      this.assocUserSearch = this.search || ''
      this.assocUserLocations = Array.isArray(this.selectedLocations) ? [...this.selectedLocations] : []
      this.assocTableSearch = ''
      this.assocTableLocations = Array.isArray(this.selectedLocations) ? [...this.selectedLocations] : []
      this.assocTableMaps = []
      this.assocTableZone = ''
      this.getAssocZones()
      this.getAssocMaps()
      this.fetchAssocUsers()
      this.fetchAssocTables()
    },
    closeAssociateTablesModal () {
      this.$modal.hide('associateTablesModal')
    },
    formatUserName (u) {
      const first = (u && u.firstname) ? u.firstname : ''
      const last = (u && u.lastname) ? u.lastname : ''
      const full = (first + ' ' + last).trim()
      return full || (u && u.name) || (u && u.email) || (u && u.id) || '-'
    },
    formatTableName (t) {
      if (!t) return '-'
      const type = t.type ? String(t.type) : ''
      const number = (t.number !== undefined && t.number !== null && String(t.number).length) ? String(t.number) : ''
      const external = t.external_id ? String(t.external_id) : ''
      const label = [type, number].filter(Boolean).join(' ')
      return label || external || ('ID ' + t.id)
    },
    isAssocUserSelected (userId) {
      return this.assocSelectedUsers.some(u => u.id === userId)
    },
    isAssocTableSelected (tableId) {
      return this.assocSelectedTables.some(t => t.id === tableId)
    },
    toggleAssocUser (user) {
      if (!user || !user.id) return
      if (this.isAssocUserSelected(user.id)) {
        this.removeAssocUser(user.id)
      } else {
        this.assocSelectedUsers = [...this.assocSelectedUsers, user]
      }
    },
    selectAllAssocUsers () {
      if (!Array.isArray(this.assocUsersResults) || !this.assocUsersResults.length) return
      const map = new Map(this.assocSelectedUsers.map(u => [u.id, u]))
      this.assocUsersResults.forEach(u => {
        if (u && u.id && !map.has(u.id)) map.set(u.id, u)
      })
      this.assocSelectedUsers = Array.from(map.values())
    },
    clearAssocUsersSelection () {
      this.assocSelectedUsers = []
    },
    removeAssocUser (userId) {
      this.assocSelectedUsers = this.assocSelectedUsers.filter(u => u.id !== userId)
    },
    toggleAssocTable (table) {
      if (!table || !table.id) return
      if (this.isAssocTableSelected(table.id)) {
        this.removeAssocTable(table.id)
      } else {
        this.assocSelectedTables = [...this.assocSelectedTables, table]
      }
    },
    selectAllAssocTables () {
      if (!Array.isArray(this.assocTablesResults) || !this.assocTablesResults.length) return
      const map = new Map(this.assocSelectedTables.map(t => [t.id, t]))
      this.assocTablesResults.forEach(t => {
        if (t && t.id && !map.has(t.id)) map.set(t.id, t)
      })
      this.assocSelectedTables = Array.from(map.values())
    },
    clearAssocTablesSelection () {
      this.assocSelectedTables = []
    },
    removeAssocTable (tableId) {
      this.assocSelectedTables = this.assocSelectedTables.filter(t => t.id !== tableId)
    },
    fetchAssocUsers () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      if (this.assocUserSearch) data.search = this.assocUserSearch
      if (Array.isArray(this.assocUserLocations) && this.assocUserLocations.length) {
        data.location_ids = this.assocUserLocations
      }

      this.assocLoadingUsers = true
      this.apiRequest('/pos/all/users', 'GET', data, response => {
        if (response && response.status === true) {
          this.assocUsersResults = response.data.pos_user || []
        } else {
          this.assocUsersResults = []
        }
        this.$nextTick(() => {
          this.assocLoadingUsers = false
        })
      })
    },
    fetchAssocTables () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      if (this.assocTableSearch) data.search = this.assocTableSearch
      if (Array.isArray(this.assocTableLocations) && this.assocTableLocations.length) {
        data.location_ids = this.assocTableLocations
      }
      if (Array.isArray(this.assocTableMaps) && this.assocTableMaps.length) {
        data.map_ids = this.assocTableMaps
      }
      if (this.assocTableZone) data.zone = this.assocTableZone

      this.assocLoadingTables = true
      this.apiRequest('/table-management', 'GET', data, (response) => {
        if (response && response.status === true) {
          this.assocTablesResults = Array.isArray(response.data)
            ? response.data
            : Object.values(response.data || {})
        } else {
          this.assocTablesResults = []
        }
        this.$nextTick(() => {
          this.assocLoadingTables = false
        })
      })
    },
    getAssocMaps () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      if (Array.isArray(this.assocTableLocations) && this.assocTableLocations.length) {
        data.location_ids = this.assocTableLocations
      }
      this.apiRequest('/pos/all/map', 'GET', data, (response) => {
        if (response && response.status === true) {
          this.assocMaps = response.data.table_maps || []
        } else {
          this.assocMaps = []
        }
      })
    },
    getAssocZones () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/table-zone', 'GET', data, (response) => {
        if (response && response.status === true && Array.isArray(response.data) && response.data.length) {
          this.assocZones = response.data.map(z => ({
            id: z.id,
            name: z.name
          }))
        } else {
          this.assocZones = []
        }
      })
    },
    async confirmAssoc () {
      if (this.assocSaving) return
      if (!this.assocSelectedUsers.length || !this.assocSelectedTables.length) return

      const userIds = this.assocSelectedUsers.map(u => u.id)
      const tableIds = this.assocSelectedTables.map(t => t.id)

      this.assocSaving = true
      try {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          table_ids: tableIds,
          user_ids: userIds
        }

        await new Promise((resolve, reject) => {
          this.apiRequest('/table-management/add-users-on-tables', 'POST', data, (response) => {
            if (response && (response.status === true || response.success === true)) {
              resolve(response)
            } else {
              reject(response)
            }
          })
        })

        swal({
          title: '',
          text: this.$t('general.success'),
          type: 'success',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {}).catch(() => {})

        this.closeAssociateTablesModal()
      } catch (e) {
        swal({
          title: '',
          text: (e && e.errors && (e.errors.message || e.errors.error)) ? (e.errors.message || e.errors.error) : this.$t('validations.wentWrong'),
          type: 'error',
          showConfirmButton: true
        }).then(() => {}).catch(() => {})
      } finally {
        this.assocSaving = false
      }
    },
    handleDelete (item) {
      var btnCounter = 3
      swal({
        text: this.$t('addOrder.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      })
      .then((result) => {
        if (result) {
          const data = {
            id: item,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/pos/user/' + item, 'DELETE', data, (response) => {
            if (response.status === true) {
              swal(
                '',
                this.$t('general.success'),
                'success'
              )
              this.getData()
            } else {
              swal(
                '',
                response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
                'error'
              )
            }
          })
          // }
        }
      })
      .catch((err) => {
        if (err) {
        }
      })
      swal.disableConfirmButton()
      const yes = this.$t('general.yes')
      const btnInterval = setInterval(() => {
        btnCounter--
        if (btnCounter >= 1) {
          if (swal.getConfirmButton()) {
            swal.getConfirmButton().textContent = `${yes} (${btnCounter})`
          }
        } else {
          if (swal.getConfirmButton()) {
            swal.getConfirmButton().textContent = yes
          }
          clearInterval(btnInterval)
          swal.enableConfirmButton()
        }
      }, 1000)
    }
  }
}
</script>

<style>
  td.error-spelling-fix-position textarea.label-notification-textarea {
    resize: vertical !important;
    overflow: hidden !important;
    min-height: auto !important;
  }

  .delivery_method{
    display: flex;
    flex-direction: column;
  }
  .delivery_method_points{
    display: flex;
    align-items: center;
    gap: 30px;
    margin-bottom: 10px;
  }

  .delivery_method_points :first-child {
    width: 300px;
  }

  .loyaltyPointsModal__footer {
    text-align: end;
  }

  .loyaltyModal {
    text-align: center;
  }

  .associate-modal {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    box-sizing: border-box;
  }

  .associate-modal__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 28px 14px 16px; /* keep content away from right scrollbar */
    background: #F4F6FF;
    border-bottom: 1px solid #eaeaea;
  }

  .associate-modal__title {
    font-weight: 600;
    font-size: 16px;
  }

  .associate-modal__body {
    padding: 16px;
    overflow: auto;
    flex: 1 1 auto;
  }

  .associate-modal__footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 12px 28px 12px 16px; /* keep buttons away from right scrollbar */
    border-top: 1px solid #eaeaea;
    background: #fff;
  }

  .associate-confirm--loading {
    pointer-events: none;
    opacity: 0.8;
  }

  .associate-section {
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 14px;
  }

  .associate-section__heading {
    font-weight: 600;
    margin-bottom: 10px;
  }

  .associate-filters {
    display: flex;
    gap: 10px;
    align-items: flex-end;
    flex-wrap: wrap;
    margin-bottom: 10px;
  }

  .associate-section__actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 10px;
  }

  .associate-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 12px;
  }

  .associate-results__title {
    font-weight: 600;
    margin-bottom: 8px;
  }

  .associate-results__list {
    border: 1px solid #eee;
    border-radius: 6px;
    height: 260px;
    overflow: auto;
    padding: 6px;
    background: #fff;
  }

  .associate-selected__box {
    border: 1px solid #eee;
    border-radius: 6px;
    height: 260px;
    overflow: auto;
    padding: 8px;
    background: #fff;
  }

  .associate-row {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    padding: 8px;
    border-radius: 6px;
    cursor: pointer;
  }

  .associate-row:hover {
    background: #f7f7f7;
  }

  .associate-row__main {
    flex: 1 1 auto;
  }

  .associate-row__name {
    font-weight: 600;
    line-height: 1.2;
  }

  .associate-row__meta {
    color: #666;
    font-size: 12px;
  }

  .associate-chip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 6px 8px;
    border: 1px solid #eee;
    border-radius: 6px;
    margin-bottom: 8px;
  }

  .associate-chip__text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .associate-empty {
    color: #888;
    padding: 10px;
  }

  @media (max-width: 1100px) {
    .associate-grid {
      grid-template-columns: 1fr;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/PosSettingsUsers.vue